module.exports = __webpack_public_path__ + "static/img/menu2-img2.74d51c1c.png";